import React, { createContext, type PropsWithChildren, useState, useContext } from 'react';

interface LocalizationValue {
  locale: string;
  setLocale: React.Dispatch<React.SetStateAction<string>>;
}

const LocalizationContext = createContext<LocalizationValue | null>(null);

export const LocalizationProvider = ({ children }: PropsWithChildren) => {
  const [locale, setLocale] = useState(navigator.language || 'ru');

  return (
    <LocalizationContext.Provider value={{ locale, setLocale }}>
      {children}
    </LocalizationContext.Provider>
  );
};

export const useLocalization = () => {
  const context = useContext(LocalizationContext);
  if (!context) throw new Error('useLocalization must be used within LocalizationProvider');
  return context;
};
